var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 182,
    viewBox: "0 0 182 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4375 39.8125H41.3212L57.3746 110.906H127.968V116.594H59.7183C56.0037 116.594 52.8437 114.22 51.6725 110.906H51.6871L36.9179 45.5H28.4375V39.8125ZM127.968 110.906L139.344 65.4062H51.1872L49.91 59.7188H50.4749C50.6047 59.7241 50.7637 59.7227 50.9585 59.7209C51.0705 59.7199 51.1944 59.7188 51.3314 59.7188H139.344L145.031 65.4062L133.656 110.906H127.968ZM65.4062 136.5C68.5474 136.5 71.0938 133.954 71.0938 130.812C71.0938 127.671 68.5474 125.125 65.4062 125.125C62.2651 125.125 59.7188 127.671 59.7188 130.812C59.7188 133.954 62.2651 136.5 65.4062 136.5ZM65.4062 142.188C71.6885 142.188 76.7812 137.095 76.7812 130.812C76.7812 124.53 71.6885 119.438 65.4062 119.438C59.124 119.438 54.0312 124.53 54.0312 130.812C54.0312 137.095 59.124 142.188 65.4062 142.188ZM122.281 130.812C122.281 133.954 119.735 136.5 116.594 136.5C113.453 136.5 110.906 133.954 110.906 130.812C110.906 127.671 113.453 125.125 116.594 125.125C119.735 125.125 122.281 127.671 122.281 130.812ZM127.969 130.812C127.969 137.095 122.876 142.188 116.594 142.188C110.312 142.188 105.219 137.095 105.219 130.812C105.219 124.53 110.312 119.438 116.594 119.438C122.876 119.438 127.969 124.53 127.969 130.812Z",
    fill: "#DEDAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOrders);
export default __webpack_public_path__ + "static/media/noOrders.c0f927e35602375c4b8ed6bb6e748836.svg";
export { ForwardRef as ReactComponent };